import Button, { ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import tokens from '@verifime/design-tokens';

export default function LoginButton({
  isShowProgress = false,
  'data-action': dataAction,
  ...props
}: { isShowProgress?: boolean; 'data-action'?: string } & ButtonProps) {
  return (
    <Button
      size="large"
      color="primary"
      fullWidth
      {...props}
      data-action={dataAction}
      sx={{
        gap: tokens.spacingXs,
        ...props.sx,
      }}
    >
      {isShowProgress && <CircularProgress color="inherit" size={tokens.fontSizeBase} />}
      {props.children}
    </Button>
  );
}
